'use client';

import { CheckCircle, Circle } from 'lucide-react';
import { useGameStore } from '@/store/useGameStore';
import badgesData from '@/data/badges.json';
import type { Question, Badge } from '@/types';

interface Props {
  question: Question;
}

export function QuestionActions({ question }: Props) {
  const isAnswered = useGameStore((s) => s.isQuestionAnswered(question.id));
  const markQuestionAnswered = useGameStore((s) => s.markQuestionAnswered);
  const checkAndUnlockBadges = useGameStore((s) => s.checkAndUnlockBadges);

  const handleMark = () => {
    if (isAnswered) return;
    markQuestionAnswered(question.id, question.xpReward, question.category);
    checkAndUnlockBadges(badgesData as Badge[]);
  };

  return (
    <button
      onClick={handleMark}
      disabled={isAnswered}
      className="flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg transition-all"
      style={
        isAnswered
          ? {
              background: 'rgba(0,201,167,0.15)',
              color: 'var(--color-secondary)',
              cursor: 'default',
            }
          : {
              background: 'var(--color-surface)',
              color: 'var(--color-text-secondary)',
              border: '1px solid var(--color-border)',
              cursor: 'pointer',
            }
      }
    >
      {isAnswered ? (
        <>
          <CheckCircle size={16} />
          Learned · +{question.xpReward} XP earned
        </>
      ) : (
        <>
          <Circle size={16} />
          Mark as Learned (+{question.xpReward} XP)
        </>
      )}
    </button>
  );
}
